<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="gateway_report_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#gateway_report_filter">
                    <div class="card-body">
                        <form @submit.prevent="action($event, query)">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('reports.terminals.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type = "button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="to_date">
                                                {{ $t('reports.terminals.to_date') }}
                                            </kt-form-label>
                                            <button id="reset_to_date"
                                                    @click="clearToDate"
                                                    class=" btn btn-label-danger trash-btn"
                                                    type = "button"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="date"
                                            />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                      <kt-form-group>
                                        <kt-form-label for="terminal_number">
                                          {{ $t('label.terminal_number') }}
                                        </kt-form-label>
                                        <kt-form-control ref="terminal_number" name="terminal_number" id="terminal_number" v-model="query.terminal_number"></kt-form-control>
                                      </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                      <kt-form-group>
                                        <kt-form-label for="shop_id">
                                          {{ $t('reports.terminals.shop_id') }}
                                        </kt-form-label>
                                        <kt-form-control ref="shop_id" name="shop_id" id="shop_id" v-model="query.shop_id"></kt-form-control>
                                      </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                      <kt-form-group>
                                        <kt-form-label for="psp">
                                          {{ $t('label.psp') }}
                                        </kt-form-label>
                                          <kt-form-select size="3" id="psp" class="form-control" name="psp" v-model="query.psp">
                                              <option
                                                  v-bind:key="index"
                                                  v-for="(psp_name, index) in psp_names"
                                                  v-bind:value="psp_name.value"
                                                  :selected="query.psp === psp_name.value"
                                              >
                                                  {{ psp_name.name }}
                                              </option>
                                          </kt-form-select>
                                      </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                      <kt-form-group>
                                        <kt-form-label for="iban_number">
                                          {{ $t('reports.terminals.iban_number') }}
                                        </kt-form-label>
                                        <kt-form-control ref="iban_number" name="iban_number" id="iban_number" v-model="query.iban_number"></kt-form-control>
                                      </kt-form-group>
                                    </kt-col>
                                </kt-form-row>
                                <kt-form-row>
                                  <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                      <kt-form-label for="tracking_number">
                                        {{ $t('reports.terminals.tracking_number') }}
                                      </kt-form-label>
                                      <kt-form-control ref="tracking_number" name="tracking_number" id="tracking_number" v-model="query.tracking_number"></kt-form-control>
                                    </kt-form-group>
                                  </kt-col>
                                  <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                      <kt-form-label for="reference_number">
                                        {{ $t('reports.terminals.reference_number') }}
                                      </kt-form-label>
                                      <kt-form-control ref="reference_number" name="reference_number" id="reference_number" v-model="query.reference_number"></kt-form-control>
                                    </kt-form-group>
                                  </kt-col>
                                  <kt-col xs="12" sm="6" md="6">
                                    <kt-form-group>
                                      <kt-form-label for="reference_number">
                                        {{ $t('reports.terminals.type') }}
                                      </kt-form-label>
                                      <select
                                          id="file_type"
                                          name="file_type"
                                          v-model="query.type"
                                          class="form-control kt-selectpicker"
                                      >
                                        <option
                                            v-bind:key="AllFileTypes.key"
                                            v-for="file_type in AllFileTypes"

                                            :value="file_type.value"
                                        >
                                          {{ file_type.name }}
                                        </option>
                                      </select>
                                    </kt-form-group>
                                  </kt-col>
                                  <kt-col xs="12" sm="6" md="6" v-if="!user_id">
                                    <kt-form-group>
                                      <kt-form-label for="user_id">
                                        {{ $t('label.user_id') }}
                                      </kt-form-label>
                                      <kt-form-control ref="user_id" name="user_id" id="user_id" v-model="query.user_id"></kt-form-control>
                                    </kt-form-group>
                                  </kt-col>
                                </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                            <kt-row>
                                <kt-col xs="12" sm="6" md="6">
                                    <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                </kt-col>
                            </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>
import $ from "jquery";
import { i18n } from '@/plugins/i18n'
import {ShaparakDownloadedFileTypes, ShaparakDownloadedFileTypesStr} from "@/constants/ShaparakDownloadedFileTypes";
import {pspName, pspNameStr} from "@/constants/pspRequestStatus";

export default {
        props: {
            action: {
                default: function(e, query) {},
                required: true,
            },
            user_id: {
                required: false,
            }
        },
        data() {
            return {
                AllFileTypes: [
                    {
                        name: ShaparakDownloadedFileTypesStr.SWITCH,
                        value: ShaparakDownloadedFileTypes.SWITCH,
                    },
                    {
                        name: ShaparakDownloadedFileTypesStr.ANNOUNCEMENT,
                        value: ShaparakDownloadedFileTypes.ANNOUNCEMENT,
                    },
                    {
                        name: ShaparakDownloadedFileTypesStr.RETURNED,
                        value: ShaparakDownloadedFileTypes.RETURNED,
                    },
                    {
                        name: this.$t('reports.terminals.shaparak_files.all'),
                        value: ''
                    }
                ],
                query: {
                    user_id:this.user_id
                },
                psp_names: [
                    {
                        name: '',
                        value: ''
                    },
                    {
                        name: pspNameStr.mellat,
                        value: pspName.mellat
                    },
                    {
                        name: pspNameStr.novin,
                        value: pspName.novin
                    },
                    {
                        name: pspNameStr.saman,
                        value: pspName.saman
                    },
                    {
                        name: pspNameStr.pasargad,
                        value: pspName.pasargad
                    },
                    {
                        name: pspNameStr.irankish,
                        value: pspName.irankish
                    },
                    {
                        name: pspNameStr.asanpardakht,
                        value: pspName.asanpardakht
                    },
                    {
                        name: pspNameStr.sepehr,
                        value: pspName.sepehr
                    },
                ],
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            },
        },
        mounted() {
            this.afterDispatch()
        },
    }
</script>

<style>

</style>
